import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserSubscriptionsById, cancelSubscription, } from "../../../Services/Subscription/subscriptionApi";
import CircularProgress from "@mui/material/CircularProgress";
import { Box } from "@mui/material";
import { toast } from "react-toastify";

const ActiveSubscriptions = () => {
    const dispatch = useDispatch();
    const subData = useSelector((state) => state.fetchUserSubscriptionsById.data);
    const loading = useSelector((state) => state.fetchUserSubscriptionsById.loading);
    const userId = localStorage.getItem("user_id");
    const [selectedSubId, setSelectedSubId] = useState(null);

    useEffect(() => {
        if (userId) {
            dispatch(fetchUserSubscriptionsById(userId));
        }
    }, [dispatch, userId]);
    console.log("sub", subData)
    const handleCancelSub = async (subscriptionId) => {
        try {
            const res = await dispatch(
                cancelSubscription({
                    user_id: userId,
                    subscription_id: subscriptionId,
                })
            ).unwrap();

            if (res.status === 200) {
                toast.success(res.message);
                dispatch(fetchUserSubscriptionsById(userId)); // Ensure the latest data is fetched
            }
        } catch (error) {
            toast.error("Failed to cancel subscription");
            console.error("Cancellation failed:", error);
        }
    };

    if (loading)
        return (
            <div>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "75vh",
                        flexDirection: "column",
                        textAlign: "center",
                    }}
                >
                    <CircularProgress size={50} sx={{ color: "#e55426" }} />
                </Box>
            </div>
        );

    return (
        <div className="community-section">
            <div className="community-inner-wrap">
                <div className="add-new-community d-flex justify-content-between align-items-center">
                    <div className="community-heading">Active Subscriptions</div>
                </div>
            </div>
            <div className="all-commmunities-table">
                {/* <div className="title-modal">Active Subscriptions</div> */}
                <div className="">
                    <div className="table-modal">
                        <table className="table table-borderless">
                            <tbody>
                                {subData?.data &&
                                    Array.isArray(subData.data) &&
                                    subData.data.length > 0 ? (
                                    subData.data
                                        .filter(sub => sub.is_active && sub.payment_status === "paid")
                                        .map((sub, index) => (
                                            <React.Fragment key={index}>
                                                <tr className="billing-innerwrap subscription-plan-tr d-flex align-items-center justify-content-between">
                                                    <td>{sub?.created_at}</td>
                                                    <td>{sub?.product_name}</td>
                                                    <td>
                                                        {/* {sub?.communites?.map((community) => (
                                                        <div key={community.community_id}>
                                                            • {community.community_name}
                                                        </div>
                                                    ))} */}
                                                        • {sub?.community_name}</td>
                                                    <td>{sub?.price_amount ? `$ ${sub?.price_amount}` : ""}</td>
                                                </tr>
                                                <tr>
                                                    {Object.keys(subData).length !== 0 ? <div className="d-flex justify-content-end gap-2">
                                                        {/* <button
                                                        className="bttn-close rounded-pill"
                                                    // onClick={() =>
                                                    //     handleCancelSub(sub?.subscription_id)
                                                    // }
                                                    >
                                                        Update subscription
                                                    </button> */}
                                                        <button
                                                            className="orange-filled-btn addcommunitybtn rounded-pill"
                                                            onClick={() =>
                                                                handleCancelSub(sub?.subscription_id)
                                                            }
                                                        >
                                                            Cancel subscription
                                                        </button>
                                                    </div> : null}
                                                </tr>
                                            </React.Fragment>
                                        ))
                                ) : (
                                    <tr className="billing-innerwrap subscription-plan-tr d-flex align-items-center justify-content-between">
                                        <td colSpan="5">No active subscriptions found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ActiveSubscriptions;

